export default "__VITE_ASSET__LGs498Fa__"